import React from 'react';

import { useField } from 'formik';

import { TracklogOtherInfoEditable } from 'ff/debrief/features/TracklogApi';
import {
    ForeFlightTextField,
    ForeFlightTextFieldProps,
} from 'ff/debrief/common/components/StyledComponents/TextFields';

type Props = {
    field: keyof TracklogOtherInfoEditable;
    multiline?: {
        maxRows: number;
    };
} & Pick<
    ForeFlightTextFieldProps,
    'fullWidth' | 'slotProps' | 'placeholder' | 'sx'
>;

const EditableField = (props: Props) => {
    const [field, meta] = useField(props.field);

    return (
        <ForeFlightTextField
            sx={{ ...props?.sx }}
            multiline={Boolean(props.multiline)}
            maxRows={props.multiline?.maxRows}
            name={field.name}
            value={field.value ?? ''}
            onChange={field.onChange}
            onBlur={field.onBlur}
            error={Boolean(meta.error)}
            helperText={meta.error || undefined}
            fullWidth={props.fullWidth}
            placeholder={props.placeholder}
            slotProps={{
                ...props.slotProps,
                htmlInput: {
                    ...props.slotProps?.htmlInput,
                    // @ts-expect-error - not resolving sx properly, but it exists for htmlInput (we're setting it here...)
                    sx: { padding: 0, ...props.slotProps?.htmlInput?.sx },
                },
                input: {
                    ...props.slotProps?.input,
                    disableUnderline: true,
                },
            }}
        />
    );
};

export default EditableField;
